import { api } from '../common.api';

export const jobseekerNotificationsApi = api.injectEndpoints({
  endpoints: (build) => ({
    jobseekerCheckProfileCompleteness: build.query<{ isComplete: boolean; notification?: any }, void>({
      query: () => ({
        url: '/jobseeker/notifications/profile-check',
        method: 'GET',
      }),
      providesTags: ['Jobseeker'],
    }),
    jobseekerCheckProfileCompletenessById: build.query<{ isComplete: boolean; notification?: any }, number>({
      query: (id) => ({
        url: `/jobseeker/notifications/profile-check/${id}`,
        method: 'GET',
      }),
      providesTags: ['Jobseeker'],
    }),
  }),
});

export const { 
  useJobseekerCheckProfileCompletenessQuery, 
  useLazyJobseekerCheckProfileCompletenessQuery,
  useJobseekerCheckProfileCompletenessByIdQuery 
} = jobseekerNotificationsApi; 